import { Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { createLazyComponent } from "./components/LazyComponentWrapper";
import LoadingScreen from "./components/LoadingScreen";
import { UserProvider } from "./providers/UserProvider";

// Lazy load components for better performance
const MainPage = createLazyComponent(() => import("./pages/MainPage"));

const QuizPage = createLazyComponent(() => import("./pages/QuizPage"));

const AboutPage = createLazyComponent(() => import("./pages/AboutPage"));

const QuizStatsPage = createLazyComponent(
  () => import("./pages/QuizStatsPage"),
);

const ArchivePage = createLazyComponent(() => import("./pages/ArchivePage"));

const StartPage = createLazyComponent(() => import("./pages/StartPage"));

const ChallengePage = createLazyComponent(
  () => import("./pages/ChallengePage"),
);

const AccountPage = createLazyComponent(() => import("./pages/AccountPage"));

const PassportPage = createLazyComponent(
  () => import("./pages/PassportPage"),
);

const PaymentReturnPage = createLazyComponent(
  () => import("./pages/PaymentReturnPage"),
);

const NotFoundPage = createLazyComponent(() => import("./pages/NotFound"));

function App() {
  useEffect(() => {
    window.snigelPubConf = {
      adengine: {
        activeAdUnits: [],
      },
    };
  }, []);

  return (
    <Router>
      <UserProvider>
        <main className="min-h-dvh">
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="account" element={<AccountPage />} />
              <Route path="passport" element={<PassportPage />} />
              <Route
                path="paymentreturn"
                element={<PaymentReturnPage />}
              />
              {/* The auth server redirects here after the OAuth flow */}
              <Route path="logged-in" element={<Navigate to="/" replace />} />
              <Route path="archive" element={<ArchivePage />} />
              <Route path="start" element={<StartPage />} />
              <Route path="challenge/:code" element={<ChallengePage />} />
              <Route path=":weekNumber" element={<QuizPage />} />
              <Route path=":weekNumber/stats" element={<QuizStatsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </main>
      </UserProvider>
    </Router>
  );
}

export default App;
